export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/sidebar-logo.png?69c8ab64fd1cfda09f22fc646c162ca4";